<template>
  <DragDialog
    title="项目发布"
    :width="1200"
    :visible.sync="visible"
    :footerBtn="[]"
    :cancel="cancel"
  >
    <div class="proj-publish-box">
      <div class="operate-area-box">
        <div class="filter-box">
          <div class="filter-item-box">
            <div class="label-box dialog-label">选择项目</div>
            <div class="common-select-box">
              <el-select
              class="primary-select"
                size="small"
                filterable
                remote
                :remote-method="filterProj"
                :loading="filterProjLoading"
                placeholder="请选择一个项目"
                v-model="projId"
                :popper-append-to-body="false"
                @change="handleProjChange"
              >
                <template slot="prefix">
                  <i slot="suffix" class="el-input__icon el-icon-search"></i>
                </template>
                <div v-infinite-scroll="handleProjScroll">
                  <el-option
                    v-for="(item, index) in projList"
                    :key="index"
                    :label="item.projName"
                    :value="item.projId"
                  />
                </div>
              </el-select>
            </div>
          </div>
          <div class="filter-item-box">
            <div class="label-box dialog-label">选择发布平台</div>
            <div class="common-select-box">
              <el-select
              class="primary-select"
                v-model="platformId"
                size="small"
                filterable
                remote
                :remote-method="filterPlatForm"
                :loading="filterPlatFormLoading"
                :popper-append-to-body="false"
                placeholder="请选择发布平台"
                @change="handlePlatFormChange"
              >
                <div v-infinite-scroll="handleScroll">
                  <el-option
                    v-for="(item, index) in platFormList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  />
                </div>
              </el-select>
            </div>
          </div>
          <div class="filter-item-box" v-if="projId">
            <div class="label-box dialog-label">选择项目所属人</div>
            <div class="common-select-box">
              <el-select
              class="primary-select"
                size="small"
                filterable
                remote
                :remote-method="filterOwner"
                :loading="filterOwnerLoading"
                placeholder="请为该项目指定一个所属人"
                v-model="projOwnerId"
                :popper-append-to-body="false"
              >
                <template slot="prefix">
                  <i slot="suffix" class="el-input__icon el-icon-search"></i>
                </template>
                <div v-infinite-scroll="handleOwnerScroll">
                  <el-option
                    v-for="(item, index) in projOwnerList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  />
                </div>
              </el-select>
            </div>
          </div>
        </div>
        <div class="common-button-box">
          <el-button
          class="normal-btn"
            type="primary"
            size="small"
            @click="publish"
            :disabled="!projId"
            >发布</el-button
          >
        </div>
      </div>
      <div class="table-box">
        <div v-if="tableLoading">
          <Spin :pointNum="8" :translateX="25" background="var(--base-primary-bgColor)"  />
        </div>
        <div class="common-table-box" v-if="dataList.length && !tableLoading">
          <el-table
            ref="dataTable"
            highlight-selection-row
            height="100%"
            class="publish-table"
            row-key="id"
            :data="dataList"
            @select="selectChange"
            @select-all="selectChange"
          >
            <el-table-column
              type="selection"
              width="60"
              :reserve-selection="true"
            /><el-table-column
              label="序号"
              type="index"
              width="75"
            ></el-table-column>
            <el-table-column label="名称/大小" width="300">
              <template v-slot="{ row }">
                <div class="text-overflow" :title="row.name">
                  {{ row.name }}
                </div>
                <div>
                  {{
                    `${formatFileSize(row.length).fileSize}${
                      formatFileSize(row.length).unit
                    }`
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="数据类型">
              <template v-slot="{ row }">
                <span>{{ getDataType(row) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="资源类型">
              <template v-slot="{ row }">
                <span v-if="row.resourceType === 0">Windows</span>
                <span v-if="row.resourceType === 1">MinIO</span>
                <span v-if="row.resourceType === -1">--</span>
              </template>
            </el-table-column>
            <el-table-column label="所属项目">
              <template v-slot="{ row }">
                <span>{{ row.projectName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="创建人">
              <template v-slot="{ row }">
                <span>{{ row.creatorName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="开始时间/完成时间" width="180">
              <template v-slot="{ row }">
                <div>{{ formatTime(row.creationTime) }}</div>
                <div>
                  {{
                    row.finishTime
                      ? formatTime(row.finishTime)
                      : formatTime(row.creationTime)
                  }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="common-empty-box" v-if="!dataList.length && !tableLoading">
          <bj-empty
            :image="require('@/assets/img/no-data.png')"
            description="请先从左上角选择已导出项目"
            class="empty-page"
          >
          </bj-empty>
        </div>
      </div>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from "@/components/CustomDragDialog.vue";
import Spin from "@/components/Spin.vue";

import { formatTime, formatFileSize } from "@/utils/generalMethods";

import {
  platformsService,
  platformsUserListService,
  getExportListService,
  publishCheckService,
  publishService,
  batchPublishService,
} from "@/service/interface";

export default {
  data() {
    return {
      filterProjLoading: false,
      projCurrPage: 1,
      allProjLoaded: false,
      filterProjName: "",
      projId: "",
      projList: [],

      filterPlatFormLoading: false,
      platFormCurrPage: 1,
      allPlatformLoaded: false,
      filterPlatFormName: "",
      platformId: "",
      platFormList: [],

      filterOwnerLoading: false,
      ownerCurrPage: 1,
      allOwnerLoaded: false,
      filterOwnerName: "",
      projOwnerId: "",
      projOwnerList: [],

      tableLoading: false,
      dataList: [],
      selectDatas: [],
    };
  },
  props: {
    visible: Boolean,
    closeDialog: Function,
  },
  components: {
    DragDialog,
    Spin,
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.filterProj();
        this.filterPlatForm();
      }
    },
  },
  methods: {
    handleProjChange() {
      this.tableLoading = true;
      this.queryExportList().then((response) => {
        let { dataList, total } = response;
        this.dataList = dataList;
        this.total = total;
        this.tableLoading = false;

        this.$nextTick(() => {
          this.$refs.dataTable.toggleAllSelection();
        });
      });
    },
    handlePlatFormChange() {
      this.ownerCurrPage = 1;
      this.queryOwnerList().then((response) => {
        let { dataList } = response;
        this.projOwnerList = dataList;
      });
    },
    selectChange(selection) {
      this.selectDatas = selection;
    },
    publish() {
      this.frontCheck().then((frontCheckResult) => {
        if (frontCheckResult) {
          this.publishCheck().then((checkResult) => {
            this.handleExceptionFiles(checkResult).then((exportIds) => {
              if (exportIds.length) {
                let publishParams = this.getPublishParams(exportIds);
                if (publishParams.exportId) {
                  publishService(publishParams).then((response) => {
                    if (response.isSuccess) {
                      this.$message.success("发布成功");
                      this.cancel();
                    } else {
                      this.$message.error(response.errMsg);
                    }
                  });
                } else {
                  batchPublishService(publishParams).then((response) => {
                    if (response.isSuccess) {
                      this.$message.success("发布成功");
                      this.cancel();
                    } else {
                      this.$message.error(response.errMsg);
                    }
                  });
                }
              }
            });
          });
        }
      });
    },
    publishCheck() {
      return new Promise((resolve) => {
        let params = this.getCheckParams();
        publishCheckService(params).then((response) => {
          let jumpFiles = [];
          let overwriteFiles = [];

          if (response.isSuccess) {
            let data = response.data;
            let { unEffectiveItems, acknowledgedItems } = data;

            if (unEffectiveItems) {
              unEffectiveItems.forEach((item) => {
                let find = jumpFiles.find(
                  (el) =>
                    el.exportType === item.exportType &&
                    el.errorMsg === item.errorMsg
                );
                if (find) {
                  find.files.push({ id: item.id, fileName: item.fileName });
                } else {
                  let obj = {
                    exportType: item.exportType,
                    errorMsg: item.errorMsg,
                    files: [{ id: item.id, fileName: item.fileName }],
                  };
                  jumpFiles.push(obj);
                }
              });
            }

            if (acknowledgedItems) {
              acknowledgedItems.forEach((item) => {
                let find = overwriteFiles.find(
                  (el) => el.exportType === item.exportType
                );
                if (find) {
                  find.files.push({ id: item.id, fileName: item.fileName });
                } else {
                  let obj = {
                    exportType: item.exportType,
                    files: [{ id: item.id, fileName: item.fileName }],
                  };
                  overwriteFiles.push(obj);
                }
              });
            }

            resolve({ jumpFiles, overwriteFiles });
          }
        });
      });
    },
    handleExceptionFiles(exceptionFile) {
      return new Promise((resolve) => {
        let { jumpFiles, overwriteFiles } = exceptionFile;

        let exportIds = this.selectDatas.map((el) => el.id);
        if (!jumpFiles.length && !overwriteFiles.length) {
          resolve(exportIds);
          return;
        }

        let find = jumpFiles.find((el) => el.exportType === 0);
        if (find) {
          this.$confirm(find.errorMsg, "提示", {
            confirmButtonText: "确定",
            showCancelButton: false,
          }).then(() => {
            // this.cancel();
            // resolve([]);
            this.$message.info("取消发布");
          });
          return;
        }

        let invalidIds = [];
        let msgTips = [];
        let msgTail = "";
        let dataTypeNames = ["项目信息", "场景", "数据集"];
        jumpFiles.forEach((item) => {
          let ids = item.files.map((el) => el.id);
          invalidIds = [...invalidIds, ...ids];
          msgTips.push(`${item.files.length}个${item.errorMsg}`);
        });
        if (msgTips.length > 1) {
          msgTips = msgTips.map((item, index) => {
            return `${index + 1}、${item}`;
          });
        }

        if (!jumpFiles.length) {
          let msgArray = [];
          overwriteFiles = overwriteFiles.sort(
            (obj1, obj2) => obj1.exportType - obj2.exportType
          );
          overwriteFiles.forEach((item) => {
            if (item.exportType === 0) {
              msgArray.push("项目信息已存在");
            } else {
              let msg = `${item.files.length}个${
                dataTypeNames[item.exportType]
              }在当前项目中已存在`;
              msgArray.push(msg);
            }
          });
          let warningMsg = `${msgArray.join("、")},是否覆盖`;
          this.$confirm(warningMsg, "提示", {
            iconClass: "null",
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              resolve(exportIds);
            })
            .catch(() => {
              // this.cancel();
              // resolve([]);
              this.$message.info("取消发布");
            });
          return;
        }

        if (this.isAllJumpFiles(exportIds, jumpFiles)) {
          let message = this.createHtml(msgTips, msgTail);
          this.$confirm(message, "提示", {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "确定",
            showCancelButton: false,
          }).then(() => {
            this.cancel();
            resolve([]);
          });
          return;
        } else {
          if (overwriteFiles.length) {
            let msgArray = [];
            overwriteFiles = overwriteFiles.sort(
              (obj1, obj2) => obj1.exportType - obj2.exportType
            );
            overwriteFiles.forEach((item) => {
              if (item.exportType === 0) {
                msgArray.push("已存在的项目信息");
              } else {
                let msg = `在当前项目中已存在的${item.files.length}个${
                  dataTypeNames[item.exportType]
                }`;
                msgArray.push(msg);
              }
            });
            let msgTail = `是否跳过继续发布，并对${msgArray.join(
              "、"
            )}进行覆盖`;
            let message = this.createHtml(msgTips, msgTail);
            this.$confirm(message, "提示", {
              dangerouslyUseHTMLString: true,
              iconClass: "null",
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                invalidIds.forEach((item) => {
                  let findIndex = exportIds.findIndex((el) => item === el);
                  if (findIndex !== -1) {
                    exportIds.splice(findIndex, 1);
                  }
                });
                resolve(exportIds);
              })
              .catch(() => {
                // this.cancel();
                // resolve([]);
                this.$message.info("取消发布");
              });
            return;
          } else {
            let message = this.createHtml(msgTips, "是否跳过继续发布");
            this.$confirm(message, "提示", {
              dangerouslyUseHTMLString: true,
              iconClass: "null",
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                invalidIds.forEach((item) => {
                  let findIndex = exportIds.findIndex((el) => item === el);
                  if (findIndex !== -1) {
                    exportIds.splice(findIndex, 1);
                  }
                });
                resolve(exportIds);
              })
              .catch(() => {
                // this.cancel();
                // resolve([]);
                this.$message.info("取消发布");
              });
          }
        }
      });
    },
    isAllJumpFiles(exportIds, jumpFiles) {
      let count = 0;
      jumpFiles.forEach((item) => {
        count += item.files.length;
      });
      if (count === exportIds.length) {
        return true;
      } else {
        return false;
      }
    },
    /**
     * 发布前端校验
     */
    frontCheck() {
      return new Promise((resolve) => {
        let checkPassed = true;
        if (!this.platformId) {
          this.$message.warning("请先选择发布平台");
          checkPassed = false;
        }

        if (!this.projOwnerId) {
          this.$message.warning("请先选择项目所属人");
          checkPassed = false;
        }

        if (!this.selectDatas.length) {
          this.$message.warning("请先勾选对应数据");
          checkPassed = false;
        }

        let projInfo = this.selectDatas.find((el) => el.exportType === 0);
        if (!projInfo) {
          this.$message.warning("请勾选项目信息");
          checkPassed = false;
        }
        resolve(checkPassed);
      });
    },
    getCheckParams() {
      let projInfo = this.selectDatas.find((el) => el.exportType === 0);
      let find = this.projOwnerList.find((el) => el.id === this.projOwnerId);
      let exportIds = this.selectDatas.map((el) => el.id);
      let checkParams = {
        publishPlatformId: this.platformId,
        targetProjectId: projInfo.projectId,
        targetProjectName: projInfo.projectName,
        targetOwnerId: this.projOwnerId,
        targetOwnerName: find.name,
        exportIds,
      };

      return checkParams;
    },
    getPublishParams(exportIds) {
      let projInfo = this.selectDatas.find((el) => el.exportType === 0);
      let find = this.projOwnerList.find((el) => el.id === this.projOwnerId);
      let publishParams = {
        publishPlatformId: this.platformId,
        targetProjectId: projInfo.projectId,
        targetProjectName: projInfo.projectName,
        targetOwnerId: this.projOwnerId,
        targetOwnerName: find.name,
      };

      if (exportIds.length === 1) {
        publishParams.exportId = exportIds[0];
      } else {
        publishParams.exportIds = exportIds;
      }

      return publishParams;
    },
    refreshExportList() {
      this.tableLoading = true;
      this.queryExportList().then((response) => {
        let { dataList, total } = response;
        this.dataList = dataList;
        this.total = total;
        this.tableLoading = false;
      });
    },
    filterProj(filterName) {
      this.projCurrPage = 1;
      this.allProjLoaded = false;
      this.filterProjName = filterName;

      this.filterProjLoading = true;
      this.queryProjList().then((response) => {
        let { dataList } = response;
        this.projList = dataList;
        this.filterProjLoading = false;
      });
    },
    handleProjScroll() {
      if (this.allProjLoaded) return;
      this.projCurrPage++;
      this.queryProjList().then((response) => {
        let { dataList } = response;
        if (dataList.length) {
          this.projList = [...this.projList, ...dataList];
        } else {
          this.allProjLoaded = true;
        }
      });
    },
    filterPlatForm(filterName) {
      this.platFormCurrPage = 1;
      this.allPlatformLoaded = false;
      this.filterPlatFormName = filterName;

      this.filterLoading = true;
      this.queryPlatFormList().then((response) => {
        let { dataList } = response;
        this.platFormList = dataList;
        this.filterLoading = false;
      });
    },
    handleScroll() {
      if (this.allPlatformLoaded) return;
      this.platFormCurrPage++;
      this.queryPlatFormList().then((response) => {
        let { dataList } = response;
        if (dataList.length) {
          this.platFormList = [...this.platFormList, ...dataList];
        } else {
          this.allPlatformLoaded = true;
        }
      });
    },
    filterOwner(filterName) {
      this.ownerCurrPage = 1;
      this.allOwnerLoaded = false;
      this.filterOwnerName = filterName;

      this.filterOwnerLoading = true;
      this.queryOwnerList().then((response) => {
        let { dataList } = response;
        this.projOwnerList = dataList;
        this.filterOwnerLoading = false;
      });
    },
    handleOwnerScroll() {
      if (this.allOwnerLoaded) return;
      this.ownerCurrPage++;
      this.queryOwnerList().then((response) => {
        let { dataList } = response;
        if (dataList.length) {
          this.projOwnerList = [...this.projOwnerList, ...dataList];
        } else {
          this.allOwnerLoaded = true;
        }
      });
    },
    cancel() {
      this.projCurrPage = 1;
      this.allProjLoaded = false;
      this.filterProjName = "";
      this.projId = "";
      this.projList = [];

      this.platFormCurrPage = 1;
      this.allPlatformLoaded = false;
      this.filterPlatFormName = "";
      this.platformId = "";
      this.platFormList = [];

      this.ownerCurrPage = 1;
      this.allOwnerLoaded = false;
      this.filterOwnerName = "";
      this.projOwnerId = "";
      this.projOwnerList = [];

      this.dataList = [];
      this.selectDatas = [];

      this.closeDialog();
    },
    queryProjList() {
      return new Promise((resolve) => {
        let params = {
          exportType: 0,
          status: 1,
          name: this.filterProjName,
          resultCount: 50,
          skipCount: (this.projCurrPage - 1) * 50,
        };
        getExportListService(params).then((response) => {
          if (response.isSuccess) {
            let data = response.data;

            let dataList = data.items.map((item) => {
              let obj = {
                projId: item.projectId,
                projName: item.projectName,
                creatorId: item.creatorId,
                creatorName: item.creatorName,
              };
              return obj;
            });
            resolve({ dataList });
          } else {
            this.$message.error(response.errMsg);
          }
        });
      });
    },
    queryPlatFormList() {
      return new Promise((resolve) => {
        let params = {
          resultCount: 50,
          skipCount: (this.platFormCurrPage - 1) * 50,
          name: this.filterPlatFormName,
        };
        platformsService(params).then((response) => {
          if (response.isSuccess) {
            let data = response.data;
            let dataList = data.items;
            dataList = dataList.filter((el) => el.liveStatus && el.status);
            resolve({ dataList });
          } else {
            this.$message.error(response.errMsg);
          }
        });
      });
    },
    queryOwnerList() {
      return new Promise((resolve) => {
        let params = {
          resultCount: 50,
          skipCount: (this.ownerCurrPage - 1) * 50,
          platformId: this.platformId,
          userName: this.filterOwnerName,
        };
        platformsUserListService(params).then((response) => {
          if (response.isSuccess) {
            let data = response.data;
            let dataList = data.items;
            resolve({ dataList });
          } else {
            this.$message.error(response.errMsg);
          }
        });
      });
    },
    queryExportList() {
      return new Promise((resolve) => {
        let params = {
          projId: this.projId,
          status: 1,
          resultCount: 5000,
          skipCount: 0,
        };
        getExportListService(params).then((response) => {
          if (response.isSuccess) {
            let data = response.data;
            let dataList = data.items;
            let total = data.totalCount;
            resolve({ dataList, total });
          } else {
            this.$message.error(response.errMsg);
          }
        });
      });
    },
    createHtml(msgTips, msgTail) {
      let htmlString = "<div>";
      msgTips.forEach((item) => {
        htmlString += `<p>${item}</p>`;
      });
      htmlString += `<p>${msgTail}</p>`;
      htmlString += "</div>";
      return htmlString;
    },
    getDataType(exportInfo) {
      let dataTypeDes = "";
      let exportType = exportInfo.exportType;
      let scheme = exportInfo.scheme;
      let formatType = exportInfo.formatType;
      switch (exportType) {
        case 0:
          dataTypeDes = "项目信息";
          break;
        case 1:
          dataTypeDes = "场景";
          break;
        case 2:
          if (scheme === "Bim") {
            if (formatType === 1) {
              dataTypeDes = "模型";
            } else {
              dataTypeDes = "模型组";
            }
          } else if (scheme === "Rs") {
            dataTypeDes = "遥感影像";
          } else if (scheme === "Wmts") {
            dataTypeDes = "WMTS";
          } else if (scheme === "Osgb") {
            dataTypeDes = "倾斜摄影";
          } else if (scheme === "Panorama") {
            dataTypeDes = "360全景图";
          } else if (scheme === "PointCloud") {
            dataTypeDes = "点云";
          } else if (scheme === "Cad") {
            dataTypeDes = "二维图纸";
          }
          break;
      }
      return dataTypeDes;
    },
    formatTime,
    formatFileSize,
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/publishSearch.less";
.proj-publish-box {
  .operate-area-box {
    display: flex;
    justify-content: space-between;
    .filter-box {
      display: flex;
      align-items: center;

      .filter-item-box {
        display: flex;
        line-height: 32px;
        color: var(--default-color);
        margin-right: 15px;

        .label-box {
          margin-right: 10px;
        }
      }
    }
  }

  .table-box {
    height: 500px;
    margin-top: 10px;

    .common-table-box {
      height: calc(100% - 30px);

      .common-pagination-box {
        margin-top: 5px;
        text-align: center;
      }
    }
  }
}
</style>